export function isSHA256Valid(sha256: string) {
    var sha256Regex = /^[a-fA-F0-9]{64}$/;

    return sha256Regex.test(sha256);
}
